import { SharedCarModule } from './../shared-car.module';
import { SharedModule } from './../../../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarOptionsComponent } from './car-options.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    SharedCarModule,
    MatTooltipModule,
  ],
  declarations: [
    CarOptionsComponent
  ],
  exports: [
    CarOptionsComponent
  ]
})
export class CarOptionsModule { }
